module.exports = __webpack_public_path__ + "img/image03.74c43869.jpg";